import * as O from 'fp-ts/lib/Option';
import {PremiumMode} from 'Agent/Policies/models/ServiceRequest/PolicyServiceRequestWithChangeRequest';

export class InvalidChangeDirectBillingSchedule {
  public readonly key = 'InvalidChangeDirectBillingSchedule';

  constructor(public readonly billingSchedule: O.Option<PremiumMode>) {}
}

export class ValidChangeDirectBillingSchedule {
  public static create(billingSchedule: O.Option<PremiumMode>) {
    return O.isSome(billingSchedule)
      ? new ValidChangeDirectBillingSchedule(billingSchedule)
      : new InvalidChangeDirectBillingSchedule(billingSchedule);
  }

  public readonly key = 'ValidChangeDirectBillingSchedule';
  constructor(public readonly billingSchedule: O.Some<PremiumMode>) {}
}

export type DirectBillingScheduleChangeRequest = ValidChangeDirectBillingSchedule | InvalidChangeDirectBillingSchedule;

export const isValidDirectBillingScheduleChange = (
  billingScheduleChange: DirectBillingScheduleChangeRequest
): billingScheduleChange is ValidChangeDirectBillingSchedule =>
  billingScheduleChange.key === 'ValidChangeDirectBillingSchedule';

export const EmptyDirectBillingScheduleChange: InvalidChangeDirectBillingSchedule = new InvalidChangeDirectBillingSchedule(
  O.none
);
